<template>
    <div>
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <el-tab-pane label="员工列表" name="staffList"></el-tab-pane>
            <el-tab-pane label="操作记录" name="operateRecord"></el-tab-pane>
            <el-tab-pane label="申请记录" name="applyRecord"></el-tab-pane>
        </el-tabs>
        <router-view class="router-view"></router-view>
    </div>
</template>

<script lang="ts">
import { createComponent, ref, onMounted } from "@vue/composition-api"
import { routerUtil } from '@/utils/routerUtil'

export default createComponent({
    setup(props, ctx) {
        const {
            activeTabName,
            handleTabClick
        } = routerUtil(ctx)

        onMounted(()=> {
            // if([667, 76].includes(Number(localStorage.getItem('shopId')))) return
            window.location.href = 'https://ls.senguo.cc/newadmin/#/main/staff/list'
        })

        return {
            activeTabName,
            handleTabClick
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    margin-bottom: 12px;
}

.router-view {
    height: calc(100vh - 134px);
}
</style>
